import { client, gql } from 'data-provider';

export const getSalesCopyDeliverySlip = async (salesId: string) => {
  const query = gql`
    query FindSalesCopyDeliverySlip($salesId: ID!) {
      findSalesCopyDeliverySlip(salesId: $salesId) {
        id
        deliveryPartner
        contactNumber
        notes
        numberOfBoxes
        shippingAddress
        sales {
          id
          client {
            id
            name
            mobileNumber
            address {
              area
              city
              country
              id
              street
              zip
            }
          }
        }
        products
      }
    }
  `;

  const variables = { salesId: salesId };

  const data = await client.request(query, variables);
  return data.findSalesCopyDeliverySlip;
};

interface ProductInfo {
  box: number;
  price: number;
  productVariantId: string;
  productName: string;
  quantity: number;
  sku: string;
  total: number;
  variantName: string;
}

interface CreateSalesCopyDeliverySlipInput {
  salesId: string | undefined;
  clientName: string;
  contactNumber: string;
  deliveryPartner: string;
  notes?: string;
  numberOfBoxes: number;
  shippingAddress: string;
  productInfo: ProductInfo[];
}

interface CreateTransferStockDeliverySlipInput {
  transferStockId: string | undefined;
  notes?: string;
  numberOfBoxes: number;
  productInfo: ProductInfo[];
}

export const createSalesCopyDeliverySlip = async (input: CreateSalesCopyDeliverySlipInput) => {
  const createSalesCopyDeliverySlipMutation = gql`
    mutation Mutation($input: createSalesCopyDeliverySlipInputDto) {
      createSalesCopyDeliverySlip(input: $input) {
        id
        deliveryPartner
        contactNumber
        notes
        numberOfBoxes
        products
        shippingAddress
        sales {
          id
        }
      }
    }
  `;

  const variables = { input };

  const createdData = await client.request(createSalesCopyDeliverySlipMutation, variables);
  return createdData;
};

export const getSalesDeliverySlip = async (id: string) => {
  const query = gql`
    query GenerateSalesCopyDeliverySlipPdf(
      $generateSalesCopyDeliverySlipPdfId: ID!
      $timeZone: String!
    ) {
      generateSalesCopyDeliverySlipPdf(timeZone: $timeZone, id: $generateSalesCopyDeliverySlipPdfId)
    }
  `;

  const variables = {
    generateSalesCopyDeliverySlipPdfId: id,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
  const data = await client.request(query, variables);
  return data.generateSalesCopyDeliverySlipPdf as string;
};

export const getSalesDeliverySticker = async (
  deliverySlipId: string,
  language: 'english' | 'bangla'
) => {
  const query = gql`
    query ($id: String!, $language: String!) {
      generateSalesCopyDeliveryStickerPdf(id: $id, language: $language)
    }
  `;

  const variables = { id: deliverySlipId, language };
  const data = await client.request(query, variables);
  return data.generateSalesCopyDeliveryStickerPdf as string;
};

export const getTransferStockDeliverySlip = async (transferStockId: string) => {
  const query = gql`
    query FindTransferStockDeliverySlip($transferStockId: ID!) {
      findTransferStockDeliverySlip(transferStockId: $transferStockId) {
        id
        numberOfBoxes
        notes
        products
        transferStock {
          transferDate
          totalStockValue
          fromWarehouse {
            name
          }
          toWarehouse {
            name
          }
        }
      }
    }
  `;

  const variables = { transferStockId };

  const data = await client.request(query, variables);
  return data.findTransferStockDeliverySlip;
};

export const createTransferStockDeliverySlip = async (
  input: CreateTransferStockDeliverySlipInput
) => {
  const mutation = gql`
    mutation ($input: createTransferStockDeliverySlipInputDto!) {
      createTransferStockDeliverySlip(input: $input) {
        id
        notes
        numberOfBoxes
        products
        transferStock {
          id
        }
      }
    }
  `;

  const variables = { input };

  const createdData = await client.request(mutation, variables);
  return createdData;
};

export const getTransferStockDeliverySlipInvoice = async (id: string) => {
  const query = gql`
    query Query($generateTransferStockDeliverySlipPdfId: ID!, $timeZone: String!) {
      generateTransferStockDeliverySlipPdf(
        id: $generateTransferStockDeliverySlipPdfId
        timeZone: $timeZone
      )
    }
  `;

  const variables = {
    generateTransferStockDeliverySlipPdfId: id,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
  const data = await client.request(query, variables);
  return data.generateTransferStockDeliverySlipPdf as string;
};
